var __rspack_ns_object = JSON.parse('{"title":"テストスクリプト","placeholder":"テストスクリプト管理機能は近日公開予定"}')